import HowItWork from './how-it-work';

export default HowItWork;
